import {useEffect, useState} from 'react';
import NextLink from 'next/link';

import {Button, TallyLogo} from '#component/base';
import {SkipToContentButton} from '#component/partial';
import {useThrottle, useViewportSize} from '#hook';

import * as css from './NavHeader.css';

export const NavHeader = () => {
  const {isMobile} = useViewportSize();
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    window.scrollY > 1 ? setScrolled(true) : setScrolled(false);
  };

  const throttledHandleScroll = useThrottle(handleScroll, 100, {leading: false, trailing: true});

  useEffect(() => {
    window.addEventListener('scroll', throttledHandleScroll);

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  });

  return (
    <header className={css.root({variant: 'light', scrolled})}>
      <SkipToContentButton />

      <div className={css.header}>
        <NextLink href="/shop" passHref>
          <a aria-label="Tally Health™" className={css.logo}>
            <TallyLogo size={isMobile ? 40 : 48} sizeType="height" color="burgundy" />
          </a>
        </NextLink>

        <NextLink href="/dashboard" passHref>
          <Button
            aria-label="Return to Dashboard"
            as="a"
            className={css.button}
            icon="X"
            variant="secondary"
          />
        </NextLink>
      </div>
    </header>
  );
};
